export enum EChargingMethod {
  INSTANT = "INSTANT",
  SMART_CHARGE = "SMART_CHARGE",
  GREEN_MODE = "GREEN_MODE",
}
